import cx from 'classnames'
import { forwardRef, useRef, useState, type InputHTMLAttributes } from 'react'

import { useSelectButtonEvent } from '@/core/analytics/hooks'

import { Label } from './Label'
import * as ToggleSwitchStyles from './styles'

interface ToggleSwitchProps extends InputHTMLAttributes<HTMLInputElement> {
  eventHook?: typeof useSelectButtonEvent
  itemId?: string
  label?: string
}

const ToggleSwitch = forwardRef<HTMLInputElement, ToggleSwitchProps>(
  (
    {
      checked,
      className,
      eventHook = useSelectButtonEvent,
      label,
      itemId,
      ...inputProps
    }: ToggleSwitchProps,
    ref,
  ) => {
    const [active, setActive] = useState(checked)
    const newRef = useRef<HTMLInputElement>(null)
    const handleEvent = eventHook({ itemId })
    const inputRef = ref || newRef

    const handleOnClick = () => {
      if (label) {
        const eventLabel = `${active ? 'habilitar' : 'desabilitar'} ${label}`
        handleEvent({ label: eventLabel })
      }

      setActive(!active)
    }

    const id = `toggle-switch-${itemId || label}`

    return (
      <ToggleSwitchStyles.Wrapper className={cx(className)}>
        <Label text={label} id={id} />
        <ToggleSwitchStyles.Container htmlFor={id}>
          <input
            type="checkbox"
            id={id}
            defaultChecked={active}
            className="toggle__input"
            onClick={handleOnClick}
            ref={inputRef}
            {...inputProps}
          />
          <ToggleSwitchStyles.Slider />
        </ToggleSwitchStyles.Container>
      </ToggleSwitchStyles.Wrapper>
    )
  },
)

ToggleSwitch.displayName = 'ToggleSwitch'

export default ToggleSwitch
